import { EqualizationPreviewTable } from "features/equalization/EqualizationPreviewTable";
import { useEqualizationRetrieveSuspense } from "gen/endpoints/equalization/equalization";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const EqualizationPage: React.FC = () => {
  const { t } = useTranslation(["common", "equalization", "capitalActivity"]);

  const { fundFamilyId, fundFamilyEventId, fundFamilySubEventId } =
    useRequiredStringParams();

  const { data: equalizationBreakdownTableData } =
    useEqualizationRetrieveSuspense(
      fundFamilyId,
      fundFamilyEventId,
      fundFamilySubEventId,
    );

  return (
    <PageContent isFullHeight={true}>
      <PageHeader
        title={t("equalization:reviewEqualization")}
        backButton={{
          title: t("capitalActivity:capitalEvents"),
          path: rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .capitalActivity({})
            .capitalActivityEvent({
              fundFamilyEventId,
            }).$,
        }}
      />
      <PageBody>
        <TableBox isFullWidth={true}>
          <TableBoxHeader>
            <TableBoxTitle>{t("common:equalizations")}</TableBoxTitle>
            <DataTableBoxActions />
          </TableBoxHeader>
          <TableBoxBody>
            <EqualizationPreviewTable
              tableData={equalizationBreakdownTableData}
            />
          </TableBoxBody>
        </TableBox>
      </PageBody>
    </PageContent>
  );
};
